import { defineNuxtPlugin, useRuntimeConfig } from '#app'
import type { Sites } from '~/types/global.types'

export default defineNuxtPlugin(() => {
    // Нужен только на клиенте
    const isProd = import.meta.env.PROD
    const { jivoWidgetEnabled, website } = useRuntimeConfig().public
    if (!isProd || !jivoWidgetEnabled) return

    // Мапа ключ → URL-скрипта (подставь реальные ссылки JivoSite)
    const JIVO_SCRIPTS: Record<Sites, string> = {
        'cromi.ru': '//code.jivo.ru/widget/uKA0emNTpE',
        'cromi.rent': '//code.jivo.ru/widget/zfobB2GkrG',
        'radioguide.rent': '//code.jivo.ru/widget/Q7iKf1FYZb',
    }

    const src = website ? JIVO_SCRIPTS[website] : undefined
    if (!src) return // неизвестный ключ — ничего не инжектим

    const injectScript = () => {
        if (document.getElementById('jivo-script')) return // уже есть
        const script = document.createElement('script')
        script.id = 'jivo-script'
        script.src = src
        script.async = true
        document.head.appendChild(script)
    }

    // Дожидаемся полной загрузки страницы, затем — указанную задержку
    const loadHandler = () => setTimeout(injectScript, Number(1000))
    if (document.readyState === 'complete') {
        loadHandler()
    } else {
        window.addEventListener('load', loadHandler, { once: true })
    }
})
